import AppAction from './action';
import * as actions from './action-types';
import {IResumenDiario, IUser} from '../../utils/models';

export function setIsAuthenticated(value: boolean): AppAction {
    return {type: actions.SET_IS_AUTHENTICATED, payload: {value},};
}

export function setIsLoading(value: boolean): AppAction {
    return {type: actions.SET_IS_LOADING, payload: {value},};
}

export function setUsuarioPerfil(value: IUser): AppAction {
    return {type: actions.SET_USUARIO_PERFIL, payload: {value},};
}

export function setIsProcessLoading(value: boolean): AppAction {
    return {type: actions.SET_IS_PROCESS_LOADING, payload: {value},};
}

export function setResumenDiarioXRuta(value: IResumenDiario[]): AppAction {
    return {type: actions.SET_RESUMEN_DIARIO_X_RUTA, payload: {value},};
}


// WEBPACK FOOTER //
// ./src/reduxstore/actions/action-creators.ts